import { render, staticRenderFns } from "./DashboardPeakLoad.vue?vue&type=template&id=af984506&scoped=true"
import script from "./DashboardPeakLoad.vue?vue&type=script&lang=js"
export * from "./DashboardPeakLoad.vue?vue&type=script&lang=js"
import style0 from "./DashboardPeakLoad.vue?vue&type=style&index=0&id=af984506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af984506",
  null
  
)

export default component.exports